import { render, staticRenderFns } from "./Pset.vue?vue&type=template&id=ba307cde&scoped=true&"
import script from "./Pset.vue?vue&type=script&lang=js&"
export * from "./Pset.vue?vue&type=script&lang=js&"
import style0 from "./Pset.vue?vue&type=style&index=0&id=ba307cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba307cde",
  null
  
)

export default component.exports